@if (label) {
    <div class="header">
        <div class="header-label">
            <div class="header-label-title">
                {{ label | translate: i18nParams }}
            </div>
        </div>
    </div>
}
<div class="main" [fui-column-width]="minColWidth" [columns]="3">
    <ng-content select="fui-column"></ng-content>
</div>

